import React from "react";
import { Box, Typography } from "@mui/material";

import CourseCard from "../../../_default/_card/CourseCard";
import CustomerCarousel from "./../../../_base/Carousel/index";
import coursesData, { top12Courses } from "../../../../_data/coursesData";
import useSmoothResponsiveFontSize from "../../../../_hook/useSmoothResponsiveFontSize";

const CoursesSection = () => {
  const customfontsize = useSmoothResponsiveFontSize();
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
          <Typography
        variant="h4"
        component="h2"
        gutterBottom
        textAlign={"start"}
        sx={{ my: 2 ,fontSize: `${1.5*customfontsize}px` }}
      >
        Featured Courses
      </Typography>
      <CustomerCarousel  data={top12Courses} CardComponent={<CourseCard  customfontsize={customfontsize}/>} />
    </Box>
  );
};

export default CoursesSection;
